export const nameDocument = (documentNames: string, index: number) => {
    const keywords = {
        "service": "Service Manual",
        "sds": "Safety Data Sheet",
        "manual": "Manual",
        "specification": "Spec Sheet",
        "spec": "Spec Sheet",
        "warranty": "Warranty",
        "catalog": "Catalog",
    }
    
    const cleanedDocName = decodeURIComponent(documentNames)
    .replace(/[^a-zA-Z0-9\s]/g, ' ')
    .toLowerCase();
    
    for (const [keyword, label] of Object.entries(keywords)) {
        if (cleanedDocName.includes(keyword)) {
            return label;
        } 
    }
    return `Document - ${index + 1}`
}